import { Component, OnChanges, SimpleChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as jsPDF from 'jspdf';
import * as jsPDFCustomFonts from 'jspdf-customfonts';
import moment from 'moment';
import { FontsProvider } from "../../../../providers/retirement-tools/fonts/fonts";


@Component({
  selector: 'resumen',
  templateUrl: 'resumen.html'
})
export class ResumenComponent implements OnChanges {
  @ViewChild("canvas1") canvas1;
  @ViewChild("canvas2") canvas2;
  @Output() formBack: EventEmitter<void> = new EventEmitter<void>();
  @Input() supuestos1 = {
    nombre: '',
    edadJubilacion: 0,
    edadIngreso: 0,
    edadActual: 0,
    antiguedad: 0,
    miEsperanzaDeVida: 0,
    esperanzaDeVidaGeneral: 0,
    semanasCotizadas: 0,
    anosCotiz: 0,
    anoImss: 1995,
    regimenJubilatorioImss: 1973,
    sueldoMensual: 0,
    sueldoIntegrado: 0,
    sueldoDiario: 0,
    factorInteg: 0,
    ingresoNeto: 0,
    planJubilacion: false,
    planEquivaleEnIL: 0,
    ahorrasParaJubilarte: false,
    ahorroIndividual: 0,
    saldoInicial: 0,
    anosAhorrando: 0,
    otrasInversiones: 0
  }
  @Input() objetivo = {
    ingresosProyectados: 0,
    gatosEstimados: 0,
    deficitSuperHabit: 0,
    deseoUnIngresoTotal: 0,
    pensionExtra: 0,
    capitalRequerido: 0,
    edadQueVivire: 0
  }
  @Input() pensionesJubilacionTotal: number = 0;
  @Input() pensionesJubilacionSubTotal: number = 0;
  @Input() pensiones = {
    imms: {
      val: 0,
      type: 0
    },
    empresa: {
      val: 0,
      factor: 0
    },
    miAhorro: {
      val: 0,
      factor: 0
    },
    inversiones: 0,
    adicional: 0,
    sueldo: 0
  }
  @Input() ahorro = {
    mensual: 0,
    conservador: 0,
    moderada: 0,
    optimista: 0
  }
  @Input() ingresos = {
    inversiones: 0,
    otras: 0
  }
  @Input() chartLabels1: string[] = [''];
  @Input() chartData1: number[] = [0];
  @Input() chartLabels2: string[] = [''];
  @Input() chartData2: number[] = [0];
  @Input() chartLabels3: string[] = [''];
  @Input() chartData3: number[] = [0];

  public doughnutChartType3: string = 'doughnut';

  public dougnutChartcolors: Array<any> = [{
    backgroundColor: ['#463685', '#59D7B5', '#f53d3d', '#007AA9', '#FFD700']
  }];
  public dougnutChartcolors3: Array<any> = [
    {
      backgroundColor: ['#007AA9', '#463685', '#59D7B5', '#f53d3d']
    }
  ];
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  }
  public doughnutChartOptions = {
    rotation: 1 * Math.PI,
    circumference: 1 * Math.PI,
    responsive: true,
    legend: { display: false }
  }
  public barChartType: string = 'bar';
  public pieChartType: string = 'doughnut';
  public max: number = 0;
  public stackedChartData2: Array<any>;
  public stackedChartData2opts: any;
  public stackedChartData2col: Array<any>;
  public type: string = 'doughnut';
  public colors: Array<any> = [{
    backgroundColor: ['#007AA9', '#463685', '#59D7B5', '#f53d3d', '#808080']
  }];
  public labels: Array<string> = [
    'Pensión Extra',
    'Otros Ingresos',
    'Ahorro Personal',
    'Pensión Empresa',
    'Pensión IMSS'
  ];

  public doughnutChartDataopts = {
    legend: { display: false }
  }

  public data: number[] = [0];

  //private cx: CanvasRenderingContext2D;
  public urlImg: any;

  public btnDisabled: boolean = false;
  fileName: string = 'GEPP myBalance.pdf';
  constructor(public fonts: FontsProvider) { }

  public dateNow(): string {
    return moment().format("DD/MM/YYYY, h:mm a");
  }

  ngOnChanges(changes: SimpleChanges) {
    this.supuestos1 = changes && changes.supuestos1 && changes.supuestos1.currentValue ? changes.supuestos1.currentValue : {};
    this.objetivo = changes && changes.objetivo && changes.objetivo.currentValue ? changes.objetivo.currentValue : {};
    this.pensionesJubilacionTotal = changes && changes.pensionesJubilacionTotal && changes.pensionesJubilacionTotal.currentValue ? changes.pensionesJubilacionTotal.currentValue : 0;
    this.pensionesJubilacionSubTotal = changes && changes.pensionesJubilacionSubTotal && changes.pensionesJubilacionSubTotal.currentValue ? changes.pensionesJubilacionSubTotal.currentValue : 0;
    this.pensiones = changes && changes.pensiones && changes.pensiones.currentValue ? changes.pensiones.currentValue : {};
    this.ahorro = changes && changes.ahorro && changes.ahorro.currentValue ? changes.ahorro.currentValue : {};
    this.ingresos = changes && changes.ingresos && changes.ingresos.currentValue ? changes.ingresos.currentValue : {};
    this.chartLabels1 = changes && changes.chartLabels1 && changes.chartLabels1.currentValue ? changes.chartLabels1.currentValue : [''];
    this.chartLabels2 = changes && changes.chartLabels2 && changes.chartLabels2.currentValue ? changes.chartLabels2.currentValue : [''];
    this.chartLabels3 = changes && changes.chartLabels3 && changes.chartLabels3.currentValue ? changes.chartLabels3.currentValue : [''];
    this.chartData1 = changes && changes.chartData1 && changes.chartData1.currentValue ? changes.chartData1.currentValue : [0];
    this.chartData2 = changes && changes.chartData2 && changes.chartData2.currentValue ? changes.chartData2.currentValue : [0];
    this.chartData3 = changes && changes.chartData3 && changes.chartData3.currentValue ? changes.chartData3.currentValue.map(element => { return Math.round(element); }) : [0];
    this.data = this.chartData2;
    this.labels = this.chartLabels2;

    this.stackedChartData2opts = {
      legend: { display: false, reverse: true },
      barPercentage: 2,
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        xAxes: [{ stacked: true }],
        yAxes: [{ stacked: true }]
      }
    };
    this.chartData1 = this.chartData1.map(element => { return Math.round(element); });
    this.chartData2 = this.chartData2.map(element => { return Math.round(element); });
    this.stackedChartData2 = [
      { label: 'Pensión IMSS', data: [this.chartData2[4]], backgroundColor: '#4DB2EB' },
      { label: 'Pensión Empresa', data: [this.chartData2[3]], backgroundColor: '#f53d3d' },
      { label: 'Ahorro Personal', data: [this.chartData2[2]], backgroundColor: '#59d7b5' },
      { label: 'Otros ingresos', data: [this.chartData2[1]], backgroundColor: '#808080' },
      { label: 'Pensión extra', data: [this.chartData2[0]], backgroundColor: '#007aa9' }
    ];
  }

  ionViewDidLoad() { }

  async imageToDataURL(url: string) {
    return await new Promise(resolve => {
      let xhr = new XMLHttpRequest();
      xhr.onload = () => {
        var reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  pdf() {
    this.btnDisabled = true;
    const doc = new jsPDF("portrait", "px", "a4");
    //const doc = new jsPDF();
    const JsPDFCustomFonts = jsPDFCustomFonts;
    doc.addFileToVFS('Montserrat-Regular.ttf', this.fonts.MonserratRegular);
    doc.addFileToVFS('Montserrat-Bold.ttf', this.fonts.MonserratBold);
    doc.addFont('Montserrat-Regular.ttf', 'Montserrat', 'normal');
    doc.addFont('Montserrat-Bold.ttf', 'Montserrat', 'bold');
    doc.setFont('Montserrat');
    const canvasEl1: HTMLCanvasElement = this.canvas1.nativeElement;
    const dataURL1 = canvasEl1.toDataURL('image/png', 1.0);
    const canvasEl2: HTMLCanvasElement = this.canvas2.nativeElement;
    const dataURL2 = canvasEl2.toDataURL('image/png', 1.0);
    const promise1 = this.imageToDataURL('assets/img/pdf/header.jpg');
    const promise2 = this.imageToDataURL('assets/img/pdf/footer.jpg');
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
    });
    let superavitDeficitTitle = '';
    let superavitDeficitValor = '';
    if (this.objetivo.deficitSuperHabit > -1) {
      superavitDeficitTitle = 'Superávit';
      superavitDeficitValor = formatter.format(Math.round(Number(this.objetivo.deficitSuperHabit)));
    } else {
      superavitDeficitTitle = 'Déficit';
      superavitDeficitValor = formatter.format(Math.round(Number(this.objetivo.deficitSuperHabit) * -1));
    }

    Promise.all([promise1, promise2]).then(values => {
      doc.addImage(values[0], 'JPEG', -1, -1, 450, 110);
      doc.addImage(values[1], 'JPEG', -1, 605, 450, 22);
      doc.setTextColor(221, 12, 12);
      doc.setFontType('bold');
      // doc.setFontSize(12);
      // doc.text(20, 590, 'Importante:');
      // doc.setFontType('normal');
      // doc.setFontSize(9);
      // doc.text(20, 600, 'Este ejercicio está basado en información proporcionada por el usuario para fines didácticos de una simulación financiera que no representa el paquete de prestaciones de la empresa. Se expresan cálculos aproximados y estimaciones que no deben de considerarse como exactos o con validez oficial. Para proteger tu privacidad y tus datos, la información que ingreses en este ejercicio no se guardará. El acceso a esta herramienta es de uso exclusivo del usuario y no debe ser compartido.');
      
      
      doc.setFontSize(8.7);
      doc.text(20, 570, 'Importante:');
      doc.setFontType('normal');
      doc.text(63, 570, 'Este ejercicio está basado en información proporcionada por el usuario para fines didácticos de una simulación');
      doc.text(20,580,'financiera que no representa el paquete de prestaciones de la empresa. Se expresan cálculos aproximados y estimaciones');
      doc.text(20,590,'que no deben de considerarse como exactos o con validez oficial. Para proteger tu privacidad y tus datos, la información que');
      doc.text(20,600,'ingreses en este ejercicio no se guardará. El acceso a esta herramienta es de uso exclusivo del usuario y no debe ser compartido.');
      
      doc.setTextColor(0, 0, 0);
      doc.text(185, 625, 'Página 1 de 2');
      /////
      doc.setTextColor(256, 256, 256);
      doc.setFontSize(16);
      doc.text(45, 102, 'Mi situación financiera a la jubilación');
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(12);
      doc.setFontType('bold');
      doc.text(20, 130, 'Fecha:');
      doc.setFontType('normal');
      doc.text(60, 130, this.dateNow());
      doc.setFontType('bold');
      doc.text(20, 145, 'Nombre:');
      doc.setFontType('normal');
      doc.text(70, 145, this.supuestos1.nombre.toString());
      doc.setFontType('bold');
      doc.text(20, 160, 'Edad actual:');
      doc.setFontType('normal');
      doc.text(90, 160, this.supuestos1.edadActual + " años");
      doc.setFontType('bold');
      doc.text(20, 175, 'Edad de jubilación:');
      doc.setFontType('normal');
      doc.text(120, 175, this.supuestos1.edadJubilacion + " años");
      doc.setFontType('bold');
      doc.text(20, 190, 'Régimen del IMSS:');
      doc.setFontType('normal');
      doc.text(115, 190, this.supuestos1.regimenJubilatorioImss.toString());
      doc.setFontType('bold');
      doc.text(20, 205, 'Años actuales de cotización en el IMSS:');
      doc.setFontType('normal');
      doc.text(210, 205, this.supuestos1.anosCotiz + " año(s)");
      doc.setFontType('bold');
      doc.text(20, 220, 'Antigüedad actual en la empresa:');
      doc.setFontType('normal');
      doc.text(190, 220, this.supuestos1.antiguedad + " año(s)");
      doc.setFontType('bold');
      doc.text(20, 235, 'Ahorro mensual actual:');
      doc.setFontType('normal');
      doc.text(135, 235, formatter.format(Math.round(Number(this.supuestos1.ahorroIndividual))));
      doc.setFontType('bold');
      doc.text(20, 250, 'Años de ahorro a la fecha actual:');
      doc.setFontType('normal');
      doc.text(180, 250, this.supuestos1.anosAhorrando.toString() + ' año(s)');
      doc.setFontType('bold');
      doc.text(20, 265, 'Inversiones (monto esperado a la jubilación):');
      doc.setFontType('normal');
      doc.text(240, 265, formatter.format(Math.round(Number(this.ingresos.inversiones))));
      doc.setFontType('bold');
      doc.text(20, 280, 'Rentas mensuales esperadas a la jubilación:');
      doc.setFontType('normal');
      doc.text(240, 280, formatter.format(Math.round(Number(this.ingresos.otras))));
      doc.setFontType('bold');
      doc.text(20, 295, 'Plan de pensiones de la empresa:');
      doc.setFontType('normal');
      doc.text(183, 295, this.supuestos1.planJubilacion ? 'Sí' : 'No');


      doc.setFontType('bold');
      doc.text(20, 310, 'Capital requerido para lograr mi objetivo de ingresos: ');
      doc.setFontType('normal');
      doc.text(280, 310, formatter.format(Math.round(Number(this.objetivo.capitalRequerido))));

      doc.setFontSize(14);
      doc.setFontType('bold');
      doc.text(135, 345, 'Tu línea de tiempo para la jubilación');
      doc.setFontSize(12);
      doc.setFontType('normal');
      doc.text(20, 370, 'Hoy');
      doc.setFontType('normal');
      doc.setFontSize(9);
      doc.text(125, 365, String((this.supuestos1 && this.supuestos1.edadJubilacion ? this.supuestos1.edadJubilacion : 0) - (this.supuestos1 && this.supuestos1.edadActual ? this.supuestos1.edadActual : 0)) + ' años');
      doc.text(305, 365, String((this.supuestos1.miEsperanzaDeVida == 0 ? this.supuestos1.esperanzaDeVidaGeneral : this.supuestos1.miEsperanzaDeVida) - this.supuestos1.edadJubilacion) + ' años');
      doc.setFontType('bold');
      doc.setFontSize(14);
      doc.text(20, 380, String(this.supuestos1 && this.supuestos1.edadActual ? String(this.supuestos1.edadActual) : 0) + ' años');
      doc.setLineWidth(1);
      doc.setDrawColor(77, 178, 235);
      doc.line(75, 370, 190, 370);
      doc.line(255, 370, 370, 370);
      doc.setFontSize(12);
      doc.setFontType('normal');
      doc.text(200, 370, 'Jubilación');
      doc.setFontType('bold');
      doc.setFontSize(14);
      doc.text(200, 380, String(this.supuestos1 && this.supuestos1.edadJubilacion ? this.supuestos1.edadJubilacion : 0) + ' años');
      doc.setFontSize(12);
      doc.setFontType('normal');
      doc.text(375, 370, 'Expectativa');
      doc.setFontType('bold');
      doc.setFontSize(14);
      doc.text(375, 380, String(this.supuestos1.miEsperanzaDeVida == 0 ? this.supuestos1.esperanzaDeVidaGeneral : this.supuestos1.miEsperanzaDeVida) + ' años');
      ///
      doc.setFontSize(14);
      doc.setFontType('bold');
      doc.text(175, 410, 'Mi balance financiero');
      doc.addImage(dataURL1, 'JPEG', 20, 430, 180, 90);

      doc.setDrawColor(0);
      doc.setFillColor(70, 54, 133);
      doc.roundedRect(230, 437, 10, 10, 3, 3, 'FD');

      doc.setDrawColor(0);
      doc.setFillColor(89, 215, 181);
      doc.roundedRect(230, 507, 10, 10, 3, 3, 'FD');

      doc.setFontSize(12);
      doc.setFontType('bold');
      doc.text(250, 445, 'Ingresos');


      doc.setFontType('bold');
      doc.text(250, 480, 'Gasto');
      doc.setFontType('normal');
      doc.text(310, 480, formatter.format(Math.round(Number(this.objetivo.gatosEstimados))));
      doc.text(310, 445, formatter.format(Math.round(Number(this.objetivo.gatosEstimados + this.objetivo.deficitSuperHabit))));
      if (this.objetivo.deficitSuperHabit > -1) {
        doc.setTextColor(0, 0, 0);
      } else {
        doc.setTextColor(221, 12, 12);
      }
      doc.setFontType('bold');
      doc.text(250, 515, superavitDeficitTitle);
      doc.setFontType('normal');
      doc.text(310, 515, superavitDeficitValor);

      ////
      doc.addPage()
      ////
      doc.addImage(values[0], 'JPEG', -1, -1, 450, 110);
      doc.addImage(values[1], 'JPEG', -1, 605, 450, 22);
      doc.setTextColor(256, 256, 256);
      doc.setFontSize(16);
      doc.text(45, 102, 'Mi situación financiera a la jubilación');
      doc.setTextColor(0, 0, 0);
      doc.setTextColor(221, 12, 12);
      doc.setFontType('bold');
      doc.setFontSize(8.7);
      doc.text(20, 570, 'Importante:');
      doc.setFontType('normal');
      doc.text(63, 570, 'Este ejercicio está basado en información proporcionada por el usuario para fines didácticos de una simulación');
      doc.text(20,580,'financiera que no representa el paquete de prestaciones de la empresa. Se expresan cálculos aproximados y estimaciones');
      doc.text(20,590,'que no deben de considerarse como exactos o con validez oficial. Para proteger tu privacidad y tus datos, la información que');
      doc.text(20,600,'ingreses en este ejercicio no se guardará. El acceso a esta herramienta es de uso exclusivo del usuario y no debe ser compartido.');
      doc.setTextColor(0, 0, 0);
      doc.text(185, 625, 'Página 2 de 2');
      /////


      doc.setTextColor(0, 0, 0);
      doc.setFontSize(12);
      doc.setFontType('bold');
      doc.text(20, 130, 'Fecha:');
      doc.setFontType('normal');
      doc.text(60, 130, this.dateNow());
      doc.setFontType('bold');
      doc.text(20, 145, 'Nombre:');
      doc.setFontType('normal');
      doc.text(70, 145, this.supuestos1.nombre.toString());


      doc.setTextColor(0, 0, 0);
      doc.setFontSize(14);
      doc.setFontType('bold');
      doc.text(165, 170, 'Mi objetivo de ingresos');
      doc.setFontSize(12);




      doc.text(20, 195, 'Objetivo:');
      doc.setFontType('normal');
      doc.text(65, 195, formatter.format(Math.round(Number(this.objetivo.deseoUnIngresoTotal))));
      doc.addImage(dataURL2, 'JPEG', 20, 210, 160, 170);
      doc.setFontSize(12);
      doc.setFontType('bold');











      doc.setDrawColor(0);
      doc.setFillColor(0, 122, 169);
      doc.roundedRect(230, 202, 10, 10, 3, 3, 'FD');
      doc.text(250, 210, 'Pensión extra:');
      doc.setFontType('normal');
      doc.text(340, 210, formatter.format(Math.round(Number(this.objetivo.pensionExtra))));

      doc.setFontType('bold');
      doc.setTextColor(221, 12, 12);
      doc.text(335, 245, '*');
      doc.setTextColor(0, 0, 0);
      doc.setDrawColor(0);
      doc.setFillColor(128, 128, 128);
      doc.roundedRect(230, 237, 10, 10, 3, 3, 'FD');
      doc.text(250, 245, 'Otros ingresos:');
      doc.setFontType('normal');
      doc.text(340, 245, formatter.format(Math.round(Number(this.pensiones.inversiones))));
      doc.setFontType('bold');

      doc.setDrawColor(0);
      doc.setFillColor(89, 215, 181);
      doc.roundedRect(230, 277, 10, 10, 3, 3, 'FD');
      doc.text(250, 285, 'Ahorro personal:');
      doc.setFontType('normal');
      doc.text(340, 285, formatter.format(Math.round(Number(this.pensiones.miAhorro.val))));
      doc.setFontType('bold');

      doc.setDrawColor(0);
      doc.setFillColor(245, 61, 61);
      doc.roundedRect(230, 317, 10, 10, 3, 3, 'FD');
      doc.text(250, 325, 'Pensión empresa:');
      doc.setFontType('normal');
      doc.text(340, 325, formatter.format(Math.round(Number(this.pensiones.empresa.val))));
      doc.setFontType('bold');

      doc.setDrawColor(0);
      doc.setFillColor(70, 54, 133);
      doc.roundedRect(230, 357, 10, 10, 3, 3, 'FD');
      doc.text(250, 365, 'Pensión IMSS:');
      doc.setFontType('normal');
      doc.text(340, 365, formatter.format(Math.round(Number(this.pensiones.imms.val))));

      doc.setTextColor(221, 12, 12);
      doc.setFontType('normal');
      doc.text(20, 400, "*");
      doc.setTextColor(0, 0, 0);
      const rentas = (this.pensiones.inversiones - this.ingresos.otras) < - 1 ? (this.pensiones.inversiones - this.ingresos.otras) * -1 : (this.pensiones.inversiones - this.ingresos.otras);
      doc.text(25, 400, "Compuesto por: Inversiones (" + formatter.format(Math.round(Number(rentas))) + "), rentas y negocios (" + formatter.format(Math.round(Number(this.ingresos.otras))) + ").");
      ///////
      doc.setFontSize(13);
      doc.setFontType('bold');
      doc.text(20, 430, '¿Qué ventaja tengo al lograr una mejor tasa de rendimiento en mis inversiones?');
      doc.setFontSize(12);
      doc.text(20, 460, 'Escenario 1 -');
      doc.setFontType('normal');
      doc.text(85, 460, 'Inversión conservadora');
      doc.setFontSize(9);
      doc.text(20, 475, '0.5% arriba de la inflación. De acuerdo con este escenario, mi ahorro mensual debería de ser:');
      doc.setFontType('bold');
      doc.setFontSize(12);
      doc.text(335, 475, formatter.format(Math.round(Number(this.ahorro.conservador) / 12)));
      doc.text(20, 500, 'Escenario 2 -');
      doc.setFontType('normal');
      doc.text(85, 500, 'Inversión moderada');
      doc.setFontSize(9);
      doc.text(20, 515, '1% arriba de la inflación. De acuerdo con este escenario, mi ahorro mensual debería de ser:');
      doc.setFontType('bold');
      doc.setFontSize(12);
      doc.text(335, 515, formatter.format(Math.round(Number(this.ahorro.moderada) / 12)));
      doc.text(20, 540, 'Escenario 3 -');
      doc.setFontType('normal');
      doc.text(85, 540, 'Inversión optimista');
      doc.setFontSize(9);
      doc.text(20, 555, '1.5% arriba de la inflación. De acuerdo con este escenario, mi ahorro mensual debería de ser:');
      doc.setFontType('bold');
      doc.setFontSize(12);
      doc.text(335, 555, formatter.format(Math.round(Number(this.ahorro.optimista) / 12)));
      doc.save(this.fileName);
    });
  }

  back(): void {
    this.formBack.emit();
  }

  ngAfterViewInit() {
    const canvasEl1: HTMLCanvasElement = this.canvas1.nativeElement;
    var dataURL = canvasEl1.toDataURL();
    this.urlImg = dataURL;
  }


}


// WEBPACK FOOTER //
// ./src/components/retirement-tools/retirement-calculator/resumen/resumen.ts